export default __webpack_public_path__ + "media/images/house-280f7391efac974dd6fdd45bb7d4206a.svg";